import React from 'react'
import { getSession, getMerchantId } from '../../utils/api'
import { mfeConfigs } from '../../utils/mfe'
import { SingleSpaParcel } from './SingleSpaParcel'
import { RouteConstants } from "../../utils/constants"

export const TaxesPage = (props) => {
    let authToken = null
    const session = getSession()
    authToken = session && session.accessToken
    const merchantId = getMerchantId()
    const company = session && session.company
    return (
        <SingleSpaParcel
            {...props}
            companyAddress={company && company.address}
            basename={RouteConstants.TAXES().BASE}
            authToken={authToken}
            merchantId={merchantId}
            config={mfeConfigs.LOAD_TAXES_PAGE}
        />
    )
}



// WEBPACK FOOTER //
// ./src/components/MfeParcels/TaxesPage.js